/** Numeric semver comparison of the first three parts; a leading `v` and pre-release/build suffixes are ignored. Invalid input sorts lowest. */
export function compareVersions(a: string, b: string): number {
  const parse = (value: string) => {
    const match = /^v?(\d+)(?:\.(\d+))?(?:\.(\d+))?/.exec(value.trim());
    return match ? [Number(match[1]), Number(match[2] ?? 0), Number(match[3] ?? 0)] : [-1, 0, 0];
  };
  const x = parse(a);
  const y = parse(b);
  for (let i = 0; i < 3; i += 1) {
    if (x[i]! !== y[i]!) return x[i]! < y[i]! ? -1 : 1;
  }
  return 0;
}

/** The server's oldest supported app version is the only bound; newer apps always pass. */
export function isAppVersionSupported(appVersion: string, supported: { min: string }): boolean {
  return compareVersions(appVersion, supported.min) >= 0;
}
